<style>
</style>

<template>
    <div class="animated fadeIn">
        <b-tabs fill>
            <b-tab v-if="false">
                <template slot="title">
                    <i class="fa fa-tag mr-2"></i>{{Core.Definition.getDefinition('Forfait')}}
                </template>
                <DynamicForm
                        ref="dynamicForm"
                        getRoot="/setting/account-plan"
                        saveRoot="/setting/account-plan"
                        @onRequestSuccess="onRequestSuccessPlan"
                        @onSave="onSavePlan"
                        :formStructure="dataFormStructures.plan">
                    <slot slot="currentPlan">
                        <h6>{{dataPlan.label}}</h6>
                        <p>
                            {{dataPlan.description}}
                        </p>
                        <table class="table table-striped mt-3">
                            <tbody>
                                <tr>
                                    <td>{{Core.Definition.getDefinition('Limite d\'envoi SMS par mois')}}</td>
                                    <td>{{dataPlan.SMSMonthlyLimit}}</td>
                                </tr>
                                <tr>
                                    <td>{{Core.Definition.getDefinition('Limite de génération PDF par mois')}}</td>
                                    <td>{{dataPlan.PDFMonthlyLimit}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </slot>
                    <slot slot="planChange">
                        <div>
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>{{Core.Definition.getDefinition('Forfait')}}</th>
                                        <th>{{Core.Definition.getDefinition('Prix')}}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="plan, planKey in dataPlans">
                                        <td>{{plan.label}}</td>
                                        <td>{{Core.Currency.format(plan.price)}} <small>{{Core.Definition.getDefinition('/ mois')}}</small></td>
                                        <td>
                                            <b-button @click="switchPlan(planKey)" :class="{ 'btn-success' : dataPlans[planKey].selected === true,'btn-light' : dataPlans[planKey].selected === false}" class="btn btn-sm">
                                                <i  class="fa fa-check"></i>
                                            </b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="text-center">
                            <a target="_blank" :href="Mantle.Config.site.URLPlans" class="btn btn-primary mr-2">
                                <i  class="fa fa-question mr-2"></i>{{Core.Definition.getDefinition('Détails sur les forfaits')}}
                            </a>
                        </div>
                    </slot>
                </DynamicForm>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <i class="fa fa-files-o mr-2"></i>{{Core.Definition.getDefinition('Facturations')}}
                </template>

                <b-row>
                    <b-col>
                        <DynamicCardList
                                ref="dynamicCardList"
                                caption="Liste des factures"
                                :columns="dataColumns"
                                root="/account-invoice/list">
                        </DynamicCardList>
                    </b-col>
                    <b-col>
                        <CCDefault entityType="environment"></CCDefault>
                    </b-col>
                </b-row>

            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import DynamicForm from '../../../components/DynamicForm'
    import CCDefault from '../../../components/CCDefault'
    import DynamicCardList from '../../../components/DynamicCardList'
    export default {
        name: 'SettingsAutoNotifications',
        components: {
            DynamicForm,
            DynamicCardList,
            CCDefault
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                Mantle: window.Mantle,
                dataFormStructures: {
                    plan: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                key: 'currentPlan',
                                                caption: Core.Definition.getDefinition('Forfait sélectionné')
                                            }
                                        ]
                                    },
                                    {
                                        cards: [
                                            {
                                                key: 'planChange',
                                                caption: Core.Definition.getDefinition('Changer votre forfait')
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                        ]
                    }
                },
                dataColumns: [
                    {
                        label: Core.Definition.getDefinition('#'),
                        key: 'id',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Date de création'),
                        key: 'creationDate',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('État'),
                        key: 'status',
                        type: 'select',
                        sortable: true
                    },
                ],
                dataPlans: [],
                dataPlan: {},
                dataCCs: []
            }
        },
        computed: {
        },
        methods: {
            onSavePlan() {
                this.$refs.dynamicForm.addSaveArg('plan',this.dataPlan.key)
            },
            onRequestSuccessPlan(data) {
                if (data.plans !== undefined) {
                    this.dataPlans = data.plans
                }
                if (data.plan !== undefined) {
                    this.dataPlan = data.plan
                }
            },
            switchPlan(plan) {
                for(let planIndex in this.dataPlans) {
                    this.dataPlans[planIndex].selected = false
                }
                this.dataPlans[plan].selected = true
                this.dataPlan = this.dataPlans[plan]
            }
        }
    }
</script>
